export const NUM_CATEGORIES = 13
export const GUEST_PASS_DURATION = 14
export const NUMBER_OF_LESSONS = 2500
